<template>
    <div class="quiz-model-page">
        <h1>Liste des models de quiz :</h1>

        <div class="btn-add-quiz">
            <span class="material-symbols-outlined" @click="openAddQuiz">add_circle</span>
        </div>

        <table>
            <tr>
                <th>Nom du quiz</th>
                <th>Date de création</th>
                <th>Nb questions</th>
                <th>Actions</th>
            </tr>

            <tr v-for="quiz in models" :key="quiz._id">
                <td>{{ quiz.name }}</td>
                <td>{{ dateToString(quiz.createdAt) }}</td>
                <td>{{ quiz.answers.length }}</td>
                <td>
                    <span class="material-symbols-outlined" @click="openQuizForm(quiz._id)">login</span>
                    <span class="material-symbols-outlined" @click="toggleCreateEvaluationModale">group_add</span>
                </td>

                <modale :show="showCreateEvaluationModale" @toggle="toggleCreateEvaluationModale">
                    <div class="evaluation-creation">
                        <div class="form-section">
                            <label>Date de l'évaluation</label>
                            <input type="datetime-local" v-model="evaluationDate">
                        </div>

                        <h2>Aprenants :</h2>

                        <multi-select
                            :elements="admins.map(admin => ({ _id: admin._id, label: `${admin.firstname} ${admin.lastname}` }))"
                            :values="[]" @closed="(result) => { selectedAdmins = result }" />

                        <div class="btn-wrapper">
                            <div :class="{'allowed': isValidCreation}" @click="createEvaluation(quiz._id)">Créer</div>
                        </div>
                    </div>
                </modale>
            </tr>
        </table>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            models: [],
            showCreateEvaluationModale: false,
            admins: [],
            selectedAdmins: [],
            evaluationDate: undefined,
        }
    },
    methods: {
        toggleCreateEvaluationModale() {
            this.showCreateEvaluationModale = !this.showCreateEvaluationModale;
        },
        openAddQuiz() {
            this.$router.replace('/academy-admin/quiz-form');
        },
        openQuizForm(id) {
            this.$router.replace('/academy-admin/quiz-form/' + id);
        },
        async loadModels() {
            const result = await axios.get(this.$store.getters.get_api_url + 'academy/quiz-models/');
            this.models = result.data;
        },
        async loadAdmins() {
            const res = await axios.get(this.$store.getters.get_api_url + 'auth/all/');
            this.admins = res.data.filter(admin => admin.is_active);
        },
        async createEvaluation(modelId) {
            if (!this.isValidCreation) return;

            await axios.post(this.$store.getters.get_api_url + 'academy/evaluation/', {
                personsEvaluatedIds: this.selectedAdmins, 
                modelId: modelId, 
                startDate: this.evaluationDate,
            });

            this.$router.replace('/academy-admin/evaluations');
        }
    },
    computed: {
        isValidCreation() {
            if (!this.evaluationDate) return false;
            else if (this.selectedAdmins.length == 0) return false;
            else return true;
        },
    },
    mounted() {
        this.loadModels();
        this.loadAdmins();
    }
}
</script>

<style scoped>
.quiz-model-page {
    padding: 20px;
}

.btn-add-quiz {
    position: absolute;
    top: 20px;
    right: 20px;
}

.btn-add-quiz .material-symbols-outlined {
    cursor: pointer;
    font-size: 48px;
}

.btn-add-quiz .material-symbols-outlined:hover {
    color: #FB984B;
}

.quiz-model-page h1 {
    font-size: 28px;
}

table {
    width: 100%;
}

table th,
table td {
    padding: 10px;
    font-size: 12px;
}

table th {
    background-color: #0A1C6B;
    color: white;
}

table td {
    background-color: white;
    text-align: center;
}

table td .material-symbols-outlined {
    margin: 0 5px;
}

table td .material-symbols-outlined:hover {
    cursor: pointer;
    color: #FB984B;
}

table tr td:first-child {
    text-align: left;
}

table tr:first-child th:first-child {
    border-top-left-radius: 10px;
}

table tr:first-child th:last-child {
    border-top-right-radius: 10px;
}

table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

.evaluation-creation {
    padding: 20px;
}

.evaluation-creation .form-section label,
.evaluation-creation .form-section input {
    font-size: 14px;
}

.evaluation-creation .btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
}
.evaluation-creation .btn-wrapper div {
    cursor: not-allowed;
    background-color: lightgrey;
    font-weight: bold;
    padding: 15px;
    border-radius: 10px;
}
.evaluation-creation .btn-wrapper div.allowed {
    cursor: pointer;
    background-color: #FB984B;
    color: white;
}
</style>